import _isNil from "lodash/isNil";
import _startCase from "lodash/startCase";

import DropdownMenu, { DropdownMenuProps } from "components/dropdown-menu";

type FilterItem = {
  name: string;
  options: DropdownMenuProps["options"];
};

export type FiltersProps = {
  filters: FilterItem[];
  onChange: (name: string, selected: string | undefined) => void;
  selected: { [key: string]: string | undefined };
};

const Filters = ({ filters, onChange, selected }: FiltersProps) => {
  if (!filters?.length || !filters.find(f => f?.options?.length)) {
    return null;
  }

  return (
    <div className="p-3 w-full mx-auto mb-10 bg-gray-100 flex gap-3 flex-wrap sm:flex-nowrap md:rounded-lg md:max-w-2xl">
      {filters.map(filter => (
        <DropdownMenu
          key={filter.name}
          {...filter}
          onChange={selected => onChange(filter.name, selected)}
          selected={selected?.[filter.name]}
          placeholder={`Filter ${filter.name}`}
          allowClear
        />
      ))}
    </div>
  );
};

export default Filters;
